import { Button, Col, Row, Space, Typography } from "antd";
import { useState } from "react";
import { Guid } from "guid-typescript";
import OrganizationalMetricsView from "../components/metrics/OrganizationalMetricsView";
import OrganizationalMetricFormDialog from "../components/metrics/OrganizationalMetricFormDialog";
import { OrganizationalMetricEntry } from "../repository/data.default";

function OrganizationalMetricsPage() {
  const [mode, setMode] = useState<"add" | "update">("add");
  const [open, setOpen] = useState(false);
  const [values, setValues] = useState<OrganizationalMetricEntry | undefined>(
    undefined,
  );
  const [triggerView, setTriggerView] = useState(Guid.create().toString());

  function onOpen(m: "add" | "update", v?: OrganizationalMetricEntry): void {
    setMode(m);
    setOpen(true);
    setValues(v);
  }

  function onFinish(): void {
    setOpen(false);
    setTriggerView(Guid.create().toString());
  }

  function onClose(): void {
    setOpen(false);
  }

  return (
    <Col className="relative flex flex-auto flex-col overflow-hidden overflow-y-auto">
      <Row className="sticky top-0 z-10 flex flex-row flex-wrap items-center p-4">
        <Typography.Title className="m-0 flex-auto" level={4}>
          Organizational Metrics
        </Typography.Title>
        <Space className="flex flex-row">
          <Button type="primary" onClick={() => onOpen("add")}>
            Add Entry
          </Button>
        </Space>
      </Row>
      <Col className="flex flex-auto flex-col overflow-hidden p-4 pb-4 pt-0">
        <OrganizationalMetricsView
          trigger={triggerView}
          onAction={(key: string, record: any) =>
            onOpen(key as "update", record)
          }
        />
      </Col>
      <OrganizationalMetricFormDialog
        mode={mode}
        open={open}
        initialValues={values}
        onFinish={onFinish}
        onCancel={onClose}
      />
    </Col>
  );
}

export default OrganizationalMetricsPage;
